module.exports = __webpack_public_path__ + "static/media/i4.0f09387a.png";